import React from 'react';
import Header from '../header/Header';
const PrivacyPolicy = () => {
  return (
    <>
    <Header />
    <div className="p-5 privacy-policy-container">
      <header className="privacy-header text-center">
        <h1>Privacy Policy</h1>
      </header>
      <section className="privacy-content">
        <p>
          At Collegiate Sports Fans Association (CSFA-US), your privacy is our priority. We are committed to safeguarding your personal data and ensuring transparency regarding how we collect, use, and share information. This policy applies to all activities on our website (<a href="http://www.csfa-us.com" target="_blank" rel="noopener noreferrer">www.csfa-us.com</a>) including chat forums, live scores, fan polls, and more.
        </p>
        <p>
          By using our services, you agree to the collection and use of your information as outlined in this policy.
        </p>

        <h4>1. Introduction</h4>
        <p>
          We value your privacy and are committed to protecting your personal data. This policy explains the types of data
          we collect, how we use it, and your rights regarding that information.
        </p>

        <h4>2. Information We Collect</h4>
        <p>We collect two types of information:</p>
        <ul>
          <li><strong>Personal Information:</strong> Information that identifies you as an individual, including:</li>
          <ul>
            <li><strong>Account Registration:</strong> When you sign up or participate in our services (e.g., chat rooms, forums, polls), we collect details such as your name, email address, username, and password.</li>
            <li><strong>Interactions:</strong> Any content you post in forums or chat rooms, including comments, messages, and shared links.</li>
          </ul>
          <li><strong>Non-personal Information:</strong> Automatically collected data such as:</li>
          <ul>
            <li><strong>Usage Data:</strong> Pages you visit, clicks on articles or advertisements, and time spent on different sections (e.g., Football News, Basketball Forum).</li>
            <li><strong>Technical Data:</strong> Browser type, IP address, device type, and operating system.</li>
            <li><strong>Cookies:</strong> We use cookies and similar tracking technologies to collect information about your browsing preferences, which helps us improve your experience (e.g., remembering your login for chat rooms or keeping your customized news feed settings).</li>
          </ul>
        </ul>

        <h4>3. How We Use Your Information</h4>
        <p>The data we collect is used to:</p>
        <ul>
          <li><strong>Provide and Enhance Services:</strong> To operate our site, including delivering live score updates, enabling fan forums, and moderating chat rooms.</li>
          <li><strong>Customizing Your Experience:</strong> Based on your interests (e.g., favorite teams or sports) and past interactions, we tailor the content displayed, such as targeted news articles or forum threads.</li>
          <li><strong>Communication:</strong> Send you important notifications, updates, newsletters, or promotional offers. You can unsubscribe from promotional emails at any time.</li>
          <li><strong>Polls and Voting:</strong> We use your information to facilitate participation in polls (e.g., NIL policy votes), ensuring you can engage in community decisions.</li>
        </ul>

        <h4>4. Data Sharing & Third Parties</h4>
        <p>We do not sell or rent your personal data to third parties. However, we may share your information under the following circumstances:</p>
        <ul>
          <li><strong>Service Providers:</strong> We work with third-party vendors to maintain our platform, ensure technical support, and handle account management. These providers are bound by confidentiality agreements.</li>
          <li><strong>Advertising Partners:</strong> Our platform may show personalized ads. We may share non-personal, aggregated data (such as demographic info) to help advertisers better target their campaigns.</li>
          <li><strong>Legal Compliance:</strong> If required by law, we may disclose your information to government authorities or third parties involved in a legal process.</li>
        </ul>

        <h4>5. Forums, Chat Rooms, and User-Generated Content</h4>
        <p>
          When you participate in our chat rooms or forums, be aware that any information you share may be publicly visible. Other users may view, share, or respond to your content. We are not responsible for how others use this information, so we encourage discretion when posting personal details.
        </p>

        <h4>6. Cookies and Tracking Technologies</h4>
        <p>We use cookies to enhance your user experience, such as remembering your login session for the live sports chat feature or keeping track of your participation in polls. You can control cookie usage through your browser settings, but please note that disabling cookies may affect your ability to access certain features.</p>
        <p>Types of Cookies We Use:</p>
        <ul>
          <li><strong>Session Cookies:</strong> These cookies help us manage your session during your visit (e.g., participating in real-time sports chats).</li>
          <li><strong>Persistent Cookies:</strong> These remain on your device to personalize your future visits (e.g., remembering your favorite team’s live scores).</li>
        </ul>

        <h4>7. Security of Your Information</h4>
        <p>
          We take appropriate technical and organizational measures to protect your personal data from unauthorized access, alteration, or destruction. This includes encryption for sensitive data (e.g., passwords) and secure servers. While we strive to protect your personal information, please be aware that no method of transmission over the internet or electronic storage is 100% secure. Therefore, we cannot guarantee its absolute security.
        </p>

        <h4>8. Changes to This Policy</h4>
        <p>We may update this privacy policy periodically. We encourage you to review this page regularly for any changes.</p>

        <h4>9. Contact Us</h4>
        <p>
          If you have any questions or concerns regarding our privacy policy, feel free to contact us at <a href="mailto:privacy@csfa-us.com">privacy@csfa-us.com</a>.
        </p>
      </section>
    </div>
    </>
  );
};

export default PrivacyPolicy;
